import { render, staticRenderFns } from "./hos_history_report.vue?vue&type=template&id=622dd520&scoped=true&"
import script from "./hos_history_report.vue?vue&type=script&lang=js&"
export * from "./hos_history_report.vue?vue&type=script&lang=js&"
import style0 from "./hos_history_report.vue?vue&type=style&index=0&id=622dd520&scoped=true&lang=css&"
import style1 from "./hos_history_report.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622dd520",
  null
  
)

export default component.exports